document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('off-animations');
});
